import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TaskStatus } from '../tasks.types';
import { TASK_STATUS_CLASSES } from '../tasks.utils';

/** The status of a task as a colored badge */
@Component({
  selector: 'app-task-status-badge',
  templateUrl: './task-status-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: { class: 'inline-flex' },
})
export class TaskStatusBadgeComponent {
  @Input({ required: true }) status!: TaskStatus;

  protected readonly classes = TASK_STATUS_CLASSES;
}
